exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-release-badge{display:inline-flex;padding:0 .125rem;border-radius:2px;background-color:var(--fts-dark);color:#fff;text-transform:uppercase;font-size:10px;font-weight:400;font-family:monospace;font-style:normal;white-space:normal;line-height:normal;letter-spacing:.25px}.fts-release-badge.editor-tool-rb{position:absolute;top:-3px;right:0}.fts-release-badge.control-modal-label-rb{height:100%;margin-left:.375rem}", ""]);

// exports
